import type { UnknownProps } from "app/pages/sales-intelligence/types";
import type { ComponentType } from "react";
import { useMount } from "app/custom-hooks/useMount";

const withTrackingHasPageBeenVisited = <P extends UnknownProps>(Component: ComponentType<P>) => {
    return function WrappedWithTrackingHasPageBeenVisited(props: P) {
        const hasPageBeenVisited = localStorage.getItem("si:has-page-been-visited");

        useMount(() => {
            if (!hasPageBeenVisited) {
                localStorage.setItem("si:has-page-been-visited", "false");
            }
        });
        return (
            <Component
                {...props}
                hasPageBeenVisited={hasPageBeenVisited}
            />
        );
    };
};

export default withTrackingHasPageBeenVisited;
